export const MuiSnackbar = () => {
    return { root: { '&.MuiSnackbar-anchorOriginTopCenter': { top: '80px' } } };
};
